const root = getComputedStyle(document.documentElement)
const colorConfig = {
  online: root.getPropertyValue('--online-color'),
  partOnline: root.getPropertyValue('--part-online-color'),
  offline: root.getPropertyValue('--offline-color'),
  alarm: root.getPropertyValue('--alarm-color'),
  isRunning: root.getPropertyValue('--is-runing-color'),
  unRunning: root.getPropertyValue('--un-runing-color'),
}
export default colorConfig
